module.exports = __webpack_public_path__ + "img/wechat_hover.fc54f7c2.svg";